import { useEffect } from 'react';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { useUrlParams } from '#hooks/useUrlParams.ts';

const ADMIN_TAB = 'admin' as const;
const ENDPOINT_TAB = 'endpoint' as const;
const PARAM_SCHEMA = { tab: 'scalar' } as const;

/**
 * This hook extracts routing logic for the sso identity provider screens.
 */
export function useSSOTabs() {
  const { state } = useAppLocation();
  const [params, setParams] = useUrlParams(PARAM_SCHEMA);

  const tab =
    params.tab === ADMIN_TAB ? ADMIN_TAB
    : params.tab === ENDPOINT_TAB ? ENDPOINT_TAB
    : ('unknown' as const);

  const tabLinkProps = {
    admin: { queryParamTarget: ADMIN_TAB },
    endpoint: { queryParamTarget: ENDPOINT_TAB },
  };

  const setTab = {
    admin: () => setParams({ tab: ADMIN_TAB }),
    endpoint: () => setParams({ tab: ENDPOINT_TAB }),
  };

  // Navigate to ADMIN_TAB by default
  useEffect(() => {
    if (tab === 'unknown') {
      setParams(
        { tab: ADMIN_TAB },
        {
          // Propagate the current state so `from` still works
          state,
          // Replace the "no tab selected" history with `admin` in the history.
          replace: true,
        }
      );
    }
  }, [setParams, state, tab]);

  return { tab, tabLinkProps, setTab };
}
